module.exports = __webpack_public_path__ + "media/white-label/state-t-e72ba686.png";